var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"size"},_vm._l((_vm.sizeBins),function(bin,index){return _c('span',{key:index,style:({ width: _vm.binWidth(bin, _vm.sizeTotal) })},[(bin > 0)?[_vm._m(0,true),_c('label',[_vm._v("\n\t\t\t\t"+_vm._s(_vm.binLabel(bin, _vm.sizeTotal))+"\n\t\t\t")])]:_vm._e()],2)}),0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('i',{staticClass:"el-icon-food"})])
}]

export { render, staticRenderFns }